import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AdditionStatus.css";
import { useSelector, useDispatch } from "react-redux";
import { getAllPendingTables } from "../Redux/Actions/pendingTableActions";

function Addition() {
  const [selectedTable, setSelectedTable] = useState(null);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const pendingTables = useSelector((state) => state.pendingTableReducer.pendingTables);

  useEffect(() => {
    dispatch(getAllPendingTables());
  }, [dispatch]);

  return (
    <div className="addition-status-container">
      <h1>Statut des Additions</h1>

      {loading ? (
        <p>Chargement des données...</p>
      ) : (
        <div className="tables-grid-container">
          <h2>Tables en attente de paiement</h2>
          <div className="tables-grid">
            {Object.keys(pendingTables).map((key) => {
              const table = pendingTables[key]; // Accède à l'objet de la table
              return (
                <button
                  key={table.tableNumber} // Utilise le numéro réel de la table
                  className="table-button"
                  onClick={() => setSelectedTable(table)}
                >
                  <div className="table-number">{table.tableNumber}</div>
                 
                </button>
              );
            })}
          </div>
        </div>
      )}

      {selectedTable && (
        <div className="addition-details-modal">
          <div className="addition-details-content">
            <h2>Détails de la Table {selectedTable.tableNumber}</h2>

            <div className="items-list">
              <div className="table-header">
                <span>Article</span>
                <span>Prix Unitaire</span>
                <span>Quantité</span>
                <span>Total</span>
              </div>

              {selectedTable.items.map((item) => (
                <div key={item.id} className="item-row">
                  <span>{item.name}</span>
                  <span>{item.price.toFixed(2)} DT</span>
                  <span>{item.quantity}</span>
                  <span>{(item.price * item.quantity).toFixed(2)} DT</span>
                </div>
              ))}
            </div>

            <div className="total-section">
              <span>Total Général:</span>
              <span>
                {selectedTable.items
                  .reduce((sum, item) => sum + item.price * item.quantity, 0)
                  .toFixed(2)} DT
              </span>
            </div>

            <button
              className="close-button"
              onClick={() => setSelectedTable(null)}
            >
              Fermer
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Addition;
